/**
 * Servicio para cálculos de boleta de pago
 * Recibe todos los datos organizados para que implementes tu lógica compleja
 */

const calculosBoletaService = {
  /**
   * Función principal - recibe todos los datos organizados con información del origen
   * @param {Object} datosCompletos - Objeto con todos los datos
   * @param {Object} datosCompletos.datosEmpresa - Información de la empresa
   * @param {Object} datosCompletos.datosAPIs - Regímenes, PLAME, fórmulas, atributos
   * @param {Object} datosCompletos.datosSalariales - Sueldo, sistema pensionario, AFP
   * @param {Object} datosCompletos.conceptosUsuario - Conceptos agregados manualmente
   * @param {Object} datosCompletos.datosEmpleado - Información del empleado
   * @param {string} origen - Origen de la llamada al servicio
   */
  async generarCalculos(datosCompletos, origen = 'formulario_empleado') {
    try {
      console.log('🧮 Servicio de cálculos iniciado');
      console.log('📍 Origen:', origen);
      console.log('📊 Datos recibidos:', datosCompletos);

      // Aquí implementas tu lógica compleja
      // Tienes acceso a todos los arrays y datos:
      
      const {
        datosEmpresa,      // Empresa seleccionada
        datosAPIs,         // regimenesLaborales, conceptosPlame, formulas, atributos
        datosSalariales,   // sueldoBasico, sistemaPensionario, afp, etc.
        conceptosUsuario,  // ingresos, descuentos, aportes agregados
        datosEmpleado      // nombres, apellidos, documento, etc.
      } = datosCompletos;

      // Información del origen para contexto
      const metadatosOrigen = {
        origen: origen,
        timestamp: new Date().toISOString(),
        fuente: this.determinarFuente(origen),
        contexto: this.obtenerContexto(origen)
      };

      console.log('📍 Metadatos del origen:', metadatosOrigen);

      // TODO: Implementar tu lógica compleja aquí
      // Ahora también tienes acceso al origen de la llamada
      if (origen === 'formulario_empleados_boton_generar') {
        console.log('🔄 Iniciando cálculos de boleta... con origen formulario_empleados_boton_generar');
        console.log('📍 Datos recibidos:', datosCompletos);
        // empesamos con el tipo de contratacion
        const tipoContratacion = datosCompletos.datosSalariales.tipoContratacion;
        const conceptosIngresos = datosCompletos.datosAPIs.conceptosPlame[20];
        const conceptosAsignacionFamiliar = datosCompletos.datosAPIs.conceptosPlame[28];
        const conceptosBono = datosCompletos.datosAPIs.conceptosPlame[117];
        const sueldoBasico = datosCompletos.datosSalariales.sueldoBasico;
        console.log('📍 Tipo de contratacion:', tipoContratacion);
        // si el tipo de contratacion es planilla, entonces se aplica el calculo de boleta
        if (tipoContratacion === 'Planilla') {
          console.log('🔄 Se aplica el calculo de boleta');
          const regimenLaboral = datosCompletos.datosSalariales.regimenLaboral;
          console.log('📍 Regimen laboral:', regimenLaboral);
          const dataIngresos = [];
          const dataDescuentos = [];
          const dataAportes = [];
          const IgGrati = []
          if (regimenLaboral === 'Régimen General') {
            console.log('🔄 Se aplica el calculo de boleta para el regimen general');
            dataIngresos.push({
                id_concepto: conceptosIngresos,
                valor: sueldoBasico
              })
              IgGrati.push({
                grati: 2,
                essalud: true
              })
              if (datosSalariales.asignacionFamiliar) {
                dataIngresos.push({
                    id_concepto: conceptosAsignacionFamiliar,
                    valor: datosAPIs.sueldoMinimo.monto * 0.1 
                  })
              }
              if (datosSalariales.tieneBono) {
                dataIngresos.push({
                    id_concepto: conceptosBono,
                    valor: datosSalariales.montoBono
                  })
              }
              console.log('datos ingresos', dataIngresos);
          }else if (regimenLaboral === 'Régimen MYPE MicroEmpresa') {
            console.log('🔄 Se aplica el calculo de boleta para el regimen de trabajo en comisaria');
            dataIngresos.push({
                id_concepto: conceptosIngresos,
                valor: sueldoBasico
              })
              IgGrati.push({
                grati: 1,
                essalud: true
              })
              if (datosSalariales.asignacionFamiliar) {
                dataIngresos.push({
                    id_concepto: conceptosAsignacionFamiliar,
                    valor: datosAPIs.sueldoMinimo.monto * 0.1 
                  })
              }
              console.log('datos ingresos', dataIngresos);
          }else if (regimenLaboral === 'Régimen MYPE Pequeña Empresa') {
            console.log('🔄 Se aplica el calculo de boleta para el regimen de trabajo en comisaria');
            dataIngresos.push({
                id_concepto: conceptosIngresos,
                valor: sueldoBasico
              })
              IgGrati.push({
                grati: 0,
                essalud: false
              })
              if (datosSalariales.asignacionFamiliar) {
                dataIngresos.push({
                    id_concepto: conceptosAsignacionFamiliar,
                    valor: datosAPIs.sueldoMinimo.monto * 0.1 
                  })
              }
              console.log('datos ingresos', dataIngresos);
              
          }else if (regimenLaboral === 'Regimen de Formacion Laboral') {
            console.log('🔄 Régimen de Formación Laboral: solo código 0121 (Remuneración Básica)');
            // Buscar el concepto 0121 (Remuneración o Jornal Básico)
            const concepto0121 = datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0121" || concepto.codigo_plame === "0121");
            if (concepto0121) {
              dataIngresos.push({
                id_concepto: concepto0121,
                valor: sueldoBasico
              });
            } else {
              console.warn('⚠️ No se encontró el concepto 0121 en conceptosPlame');
            }
            // No se agregan descuentos ni aportes para este régimen
            console.log('datos ingresos (solo 0121):', dataIngresos);
            
            // Retornar directamente sin calcular descuentos ni aportes
            return {
              success: true,
              data: {
                mensaje: 'Régimen de Formación Laboral: solo ingreso básico (0121)',
                origen: metadatosOrigen,
                dataIngresos: dataIngresos,
                dataDescuentos: [],
                dataAportes: []
              },
              message: 'Servicio ejecutado exitosamente'
            };
          }else{
            return {
                success: false,
                error: 'No se puede calcular la boleta para este regimen laboral',
                data: null
              };
          }

          const idRegimenLaboral = datosCompletos.datosAPIs.regimenesLaborales.find(regimen => regimen.nombre === regimenLaboral);
          // calculo descuentos
          const tipoAporte = datosCompletos.datosSalariales.sistemaPensionario;

          let baseCalculo = 0
          

          // calculo descuentos
          if (tipoAporte ==='AFP'){
            console.log('tipoAporte', tipoAporte);
            let porA = 0
            // primero el tipo de comision el codigo es 0601
            console.log('datosCompletos.datosSalariales.tipoAfp', datosCompletos.datosSalariales.tipoAfp);
            if (datosCompletos.datosSalariales.tipoAfp === 'Flujo'){
              const ComixAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == datosCompletos.datosSalariales.afp);
              console.log('ComixAFP', ComixAFP);
              porA = ComixAFP.comision_fija;
              console.log('porA', porA);
            }else{
              const ComixAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == datosCompletos.datosSalariales.afp);
              console.log('ComixAFP', ComixAFP);
              porA = ComixAFP.comision_variable;
              console.log('porA', porA);
            }

            const formulas = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0601");
            console.log('formula para comision AFP', formulas);

            const formulaAFPcomision = formulas.formula;
            console.log('formulaAFPcomision', formulaAFPcomision);
            
            dataIngresos.forEach(
              ingreso => {
                  const afectaSistemaPrivado = ingreso.id_concepto?.afectaciones?.sistema_privado_pension || ingreso.id_concepto?.sistema_privado_pension;
                  if(afectaSistemaPrivado){
                      baseCalculo += ingreso.valor;
                  }
              }
            );
            const formulaReemplazada = formulaAFPcomision.replace('R', baseCalculo);
            console.log('formulaReemplazada', formulaReemplazada);
            const remmplazarA = formulaReemplazada.replace('A', porA/100);
            console.log('remmplazarA', remmplazarA);
            const descuento = eval(remmplazarA);
            console.log('descuento', descuento);
            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0601"),
                valor: descuento.toFixed(2)
            })

            // ahora el decuento para el codigo 0606 (Seguro AFP) - Cero si el empleado tiene 65 años o más
            baseCalculo = 0;

            const fechaNacimiento = datosCompletos.datosEmpleado?.fechaNacimiento;
            let edadEmpleado = null;
            if (fechaNacimiento) {
              const nacimiento = new Date(fechaNacimiento);
              const hoy = new Date();
              edadEmpleado = hoy.getFullYear() - nacimiento.getFullYear();
              const cumpleEsteAnio = new Date(hoy.getFullYear(), nacimiento.getMonth(), nacimiento.getDate());
              if (hoy < cumpleEsteAnio) edadEmpleado -= 1;
              console.log('📅 Edad empleado (seguro AFP):', edadEmpleado, 'años');
            }

            let Segdescuento = 0;
            if (edadEmpleado !== null && edadEmpleado >= 65) {
              console.log('✅ Empleado con 65 años o más: seguro AFP (0606) = 0');
            } else {
              const SegAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre ==datosCompletos.datosSalariales.afp);
              console.log('SegAFP', SegAFP);
              const SegA = SegAFP.seguro;
              console.log('SegA', SegA);

              const formulasSegAFP = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0606");
              console.log('formula para seguro AFP', formulasSegAFP);

              const formulaSegAFP = formulasSegAFP.formula;
              console.log('formulaAFPcomision', formulaAFPcomision);

              dataIngresos.forEach(
                ingreso => {
                    const afectaSistemaPrivado = ingreso.id_concepto?.afectaciones?.sistema_privado_pension || ingreso.id_concepto?.sistema_privado_pension;
                    if(afectaSistemaPrivado){
                        baseCalculo += ingreso.valor;
                    }
                }
              );

              const formulaSegReemplazada = formulaSegAFP.replace('R', baseCalculo);
              console.log('formulaSegReemplazada', formulaSegReemplazada);
              const SegReemplazada = formulaSegReemplazada.replace('A', SegA/100);
              console.log('SegReemplazada', SegReemplazada);
              Segdescuento = eval(SegReemplazada);
              console.log('Segdescuento', Segdescuento);
            }

            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0606"),
                valor: Segdescuento.toFixed(2)
            })

            // ahora el decuento para el codigo 0608
            baseCalculo = 0;

            const AporAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == datosCompletos.datosSalariales.afp);
            console.log('AporAFP', AporAFP);
            const AporA = AporAFP.aporte;
            console.log('AporA', AporA);

            const formulasAporAFP = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0608");
            console.log('formula para aporte AFP', formulasAporAFP);

            const formulaAporAFP = formulasAporAFP.formula;
            console.log('formulaAporAFP', formulaAporAFP);
            
            dataIngresos.forEach(
              ingreso => {
                  const afectaSistemaPrivado = ingreso.id_concepto?.afectaciones?.sistema_privado_pension || ingreso.id_concepto?.sistema_privado_pension;
                  if(afectaSistemaPrivado){
                      baseCalculo += ingreso.valor;
                  }
              }
            );

            const formulaAporReemplazada = formulaAporAFP.replace('R', baseCalculo);
            console.log('formulaAporReemplazada', formulaAporReemplazada);
            const AporReemplazada = formulaAporReemplazada.replace('A', AporA/100);
            console.log('AporReemplazada', AporReemplazada);
            const Apordescuento = eval(AporReemplazada);
            console.log('Apordescuento', Apordescuento);
            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0608"),
                valor: Apordescuento.toFixed(2)
            })

           console.log('datos descuentos', dataDescuentos);

          }else{//ONP

            // busqueda de id en regimen laboral  
            console.log('idRegimenLaboral', idRegimenLaboral.id);

            // busqueda de formulas segun idRegimenLaboral y codigo plame
            const formulas = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0607");
            console.log('formula PARA ONP', formulas);
            
            const formulaONP = formulas.formula;
            console.log('formulaONP', formulaONP);

            // calculo base de calculo para descuento ONP
            dataIngresos.forEach(
                ingreso => {
                    const afectaSistemaNacional = ingreso.id_concepto?.afectaciones?.sistema_nacional_19990 || ingreso.id_concepto?.sistema_nacional_19990;
                    if(afectaSistemaNacional){
                        baseCalculo += ingreso.valor * 1;
                    }
                }
            );

            const formulaReemplazada = formulaONP.replace('R', baseCalculo);
            console.log('formulaReemplazada', formulaReemplazada);
            const descuento = eval(formulaReemplazada);
            
            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0607"),
                valor: descuento.toFixed(2)
            })
            console.log('datos descuentos', dataDescuentos);
          }
          // seguimos con descuentos ahora haremos renta

          // 💰 VALIDAR SI LA CONFIGURACIÓN DE RENTA DE QUINTA ESTÁ ACTIVADA
          const rentaQuintaActivada = datosCompletos.datosAPIs?.rentaQuintaActivada || datosCompletos.datosAPIs?.configuracionRentaQuinta?.activo || false;
          console.log('💸 Configuración de Renta de Quinta:', datosCompletos.datosAPIs?.configuracionRentaQuinta);
          console.log('🔄 Renta de Quinta Activada:', rentaQuintaActivada);

          if (rentaQuintaActivada) {
            console.log('✅ Renta de quinta activada, procediendo con el cálculo...');
            
            baseCalculo = 0;
            // primero calculamos los ingresos afectos a renta
            dataIngresos.forEach(
                ingreso => {
                    if((ingreso.id_concepto?.afectaciones?.renta_5ta_categoria) || (ingreso.id_concepto?.renta_5ta_categoria)){
                        baseCalculo += ingreso.valor * 1;
                    }
                }
            );

            console.log('baseCalculo Renta', baseCalculo);
            console.log('grati', IgGrati[0].grati);
            console.log('essalud', IgGrati[0].essalud);

            // empesamos con proyecciones de renta
            const proyeccionIngreso  = baseCalculo * 12
            const proyeccionGrati = baseCalculo * IgGrati[0].grati
            const proyeccionEssalud = IgGrati[0].essalud ? (baseCalculo * 0.09) * IgGrati[0].grati : 0

            console.log('proyeccionIngreso', proyeccionIngreso);
            console.log('proyeccionGrati', proyeccionGrati);
            console.log('proyeccionEssalud', proyeccionEssalud);

            // ahora calculamos la renta
            const SumatorioRenta = proyeccionIngreso + proyeccionGrati + proyeccionEssalud
            console.log('SumatorioRenta', SumatorioRenta);

            
            if(SumatorioRenta > datosCompletos.datosAPIs.uit.monto * 7){
              console.log('se aplica renta');
              const BIrenta = SumatorioRenta - (datosCompletos.datosAPIs.uit.monto * 7)
              console.log('renta', BIrenta);

              // empesamos con los tramos de renta
              const tramo1 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 1)
              if (BIrenta > tramo1.hasta * datosCompletos.datosAPIs.uit.monto){
                  const tramo2 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 2)
                  if (BIrenta > tramo2.hasta * datosCompletos.datosAPIs.uit.monto){
                      const tramo3 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 3)
                      if (BIrenta > tramo3.hasta * datosCompletos.datosAPIs.uit.monto){
                          const tramo4 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 4)
                          if (BIrenta > tramo4.hasta * datosCompletos.datosAPIs.uit.monto){
                              const tramo5 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 5)
                              if (BIrenta > tramo5.hasta * datosCompletos.datosAPIs.uit.monto){
                                const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                                const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                                const RetencionTramo3 = ((BIrenta - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo3.tasa/100))
                                const RetencionTramo4 = ((BIrenta - (tramo3.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo4.tasa/100))
                                const RetencionTramo5 = ((BIrenta - (tramo4.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo3.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo5.tasa/100))
                                const RetencionRenta = (RetencionTramo1 + RetencionTramo2 + RetencionTramo3 + RetencionTramo4 + RetencionTramo5)/12
                                console.log('RetencionRenta', RetencionRenta);
                                dataDescuentos.push({
                                  id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605"),
                                  valor: RetencionRenta.toFixed(2)
                              })
                              }
                          }else{
                            const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                            const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                            const RetencionTramo3 = ((BIrenta - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo3.tasa/100))
                            const RetencionTramo4 = ((BIrenta - (tramo3.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo4.tasa/100))
                            const RetencionRenta = (RetencionTramo1 + RetencionTramo2 + RetencionTramo3 + RetencionTramo4)/12
                            console.log('RetencionRenta', RetencionRenta);
                            dataDescuentos.push({
                              id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605"),
                              valor: RetencionRenta.toFixed(2)
                          })
                          }
                      }else{
                        const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                        const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                        const RetencionTramo3 = ((BIrenta - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo3.tasa/100))
                        const RetencionRenta = (RetencionTramo1 + RetencionTramo2 + RetencionTramo3)/12
                        console.log('RetencionRenta', RetencionRenta);
                        dataDescuentos.push({
                          id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605"),
                          valor: RetencionRenta.toFixed(2)
                      })
                      }
                  }else{
                    const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                    const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                    const RetencionRenta = (RetencionTramo1 + RetencionTramo2)/12
                    console.log('RetencionRenta', RetencionRenta);
                    dataDescuentos.push({
                      id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605"),
                      valor: RetencionRenta.toFixed(2) 
                  })
                  }
              }else{
                const RetencionRenta = (BIrenta * (tramo1.tasa/100))/12
                console.log('RetencionRenta', RetencionRenta);
                dataDescuentos.push({
                  id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605"),
                  valor: RetencionRenta.toFixed(2)
              })
              }
            }else{
              console.log('no se aplica renta');
            }
          } else {
            console.log('❌ Renta de quinta desactivada en la configuración, saltando cálculo...');
          }

          // ahora calculamos los aportes
          // busqueda de id en regimen laboral  
          console.log('idRegimenLaboral', idRegimenLaboral.id);

          // busqueda de formulas segun idRegimenLaboral y codigo plame
          const formulasEssalud = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0804");
          console.log('formula para Essalud', formulasEssalud);
          
          const formulaEssalud = formulasEssalud.formula;
          console.log('formulaEssalud', formulaEssalud);

          // calculo base de calculo para descuento Essalud
          dataIngresos.forEach(
              ingreso => {
                  console.log('ingreso', ingreso.id_concepto.essalud_regular);
                  if(ingreso.id_concepto.essalud_regular){
                      baseCalculo += ingreso.valor;
                  }
              }
          );

          // comprar con el sueldo minimo
          if(baseCalculo < datosCompletos.datosAPIs.sueldoMinimo.monto){
            baseCalculo = datosCompletos.datosAPIs.sueldoMinimo.monto;
          }

          const formulaReemplazadaEss = formulaEssalud.replace('R', baseCalculo);
          console.log('formulaReemplazadaEss', formulaReemplazadaEss);
          const descuentoEssalud = eval(formulaReemplazadaEss);
          console.log('descuentoEssalud', descuentoEssalud);

          dataAportes.push({
              id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0804"),
              valor: descuentoEssalud.toFixed(2)
          })

          
          console.log('datos aportes', dataAportes);

          

          return {
            success: true,
            data: {
              // Aquí devuelves los resultados de tus cálculos
              mensaje: 'Datos recibidos correctamente - implementa tu lógica aquí',
              origen: metadatosOrigen,
              dataIngresos: dataIngresos,
              dataDescuentos: dataDescuentos,
              dataAportes: dataAportes
            },
            message: 'Servicio ejecutado exitosamente'
          };

        }else{
          console.log('🔄 No se aplica el calculo de boleta, solo aplica ingresos sin descuentos');
          // calculamos el ingreso basico
          console.log('concepto ingresos', conceptosIngresos);
          console.log('sueldo basico', sueldoBasico);
          const regimenLaboral = datosCompletos.datosSalariales.regimenLaboral;
          console.log('📍 Regimen laboral:', regimenLaboral);
          const dataIngresos = {
            id_concepto: conceptosIngresos,
            valor: sueldoBasico
          }
          console.log('datos ingresos', dataIngresos);
          return {
            success: true,
            data: {
              // Aquí devuelves los resultados de tus cálculos
              mensaje: 'Datos recibidos correctamente - implementa tu lógica aquí',
              origen: metadatosOrigen,
              dataIngresos: dataIngresos
            },
            message: 'Servicio ejecutado exitosamente'
          };
        }
      }else{
        console.log('🔄 Iniciando cálculos de edición de boleta...');
        console.log('📍 Datos recibidos:', datosCompletos);
        const regimenLaboral = datosCompletos.datosSalariales.regimenLaboral;

        console.log('📍 Regimen laboral:', regimenLaboral);
        // empesamos con el tipo de contratacion
        const tipoContratacion = datosCompletos.datosSalariales.tipoContratacion;
        if (tipoContratacion === 'Planilla') {
          console.log('🔄 Se aplica el calculo de boleta');
          const dataIngresos = [];
          const dataDescuentos = [];
          const dataAportes = [];

          const IgGrati = [];

          datosCompletos.conceptosUsuario.ingresos.forEach(ingreso => {
              const dataIngreso = datosCompletos.datosAPIs.conceptosIngresos.find(concepto => concepto.codigo === ingreso.codigoPlame || concepto.codigo_plame === ingreso.codigoPlame);
              dataIngresos.push({
                id_concepto: dataIngreso,
                valor: ingreso.monto
              });
            });
          console.log('dataIngresos', dataIngresos);

          if (regimenLaboral === 'Régimen General') {
            console.log('🔄 Se aplica el calculo de boleta para el regimen general');
              IgGrati.push({
                grati: 2,
                essalud: true
              })
              console.log('datos ingresos', dataIngresos);
          }else if (regimenLaboral === 'Régimen MYPE MicroEmpresa') {
            console.log('🔄 Se aplica el calculo de boleta para el regimen de trabajo en comisaria');
              IgGrati.push({
                grati: 1,
                essalud: true
              })
              console.log('datos ingresos', dataIngresos);
          }else if (regimenLaboral === 'Régimen MYPE Pequeña Empresa') {
            console.log('🔄 Se aplica el calculo de boleta para el regimen de trabajo en comisaria');
              IgGrati.push({
                grati: 0,
                essalud: false
              })
              console.log('datos ingresos', dataIngresos);
              
          }else if (regimenLaboral === 'Regimen de Formacion Laboral') {
            console.log('🔄 Régimen de Formación Laboral (edición): solo código 0121; descuentos y aportes (ONP, AFP, EsSalud, Renta) se pasan del usuario');
            // Filtrar solo el concepto 0121 de los ingresos del usuario
            const ingresosFormacion = [];
            datosCompletos.conceptosUsuario.ingresos.forEach(ingreso => {
              if (ingreso.codigoPlame === "0121") {
                const dataIngreso = datosCompletos.datosAPIs.conceptosIngresos.find(concepto => concepto.codigo === "0121" || concepto.codigo_plame === "0121");
                if (dataIngreso) {
                  ingresosFormacion.push({
                    id_concepto: dataIngreso,
                    valor: ingreso.monto
                  });
                }
              }
            });
            console.log('datos ingresos (solo 0121):', ingresosFormacion);

            // Pasar descuentos del usuario (no se calculan ONP, AFP, EsSalud, Renta en este régimen)
            const dataDescuentosFormacion = [];
            if (datosCompletos.conceptosUsuario.descuentos && Array.isArray(datosCompletos.conceptosUsuario.descuentos)) {
              datosCompletos.conceptosUsuario.descuentos.forEach(descuento => {
                const dataDescuento = datosCompletos.datosAPIs.conceptosDescuentos?.find(concepto => concepto.codigo === descuento.codigoPlame || concepto.codigo_plame === descuento.codigoPlame);
                if (dataDescuento) {
                  dataDescuentosFormacion.push({
                    id_concepto: dataDescuento,
                    valor: descuento.monto
                  });
                }
              });
            }
            // Pasar aportes del usuario (no se calcula EsSalud 0804 en este régimen)
            const dataAportesFormacion = [];
            if (datosCompletos.conceptosUsuario.aportes && Array.isArray(datosCompletos.conceptosUsuario.aportes)) {
              datosCompletos.conceptosUsuario.aportes.forEach(aporte => {
                const dataAporte = datosCompletos.datosAPIs.conceptosAportes?.find(concepto => (concepto.codigo === aporte.codigoPlame || concepto.codigo_plame === aporte.codigoPlame));
                if (dataAporte) {
                  dataAportesFormacion.push({
                    id_concepto: dataAporte,
                    valor: aporte.monto
                  });
                }
              });
            }
            console.log('datos descuentos (pasados del usuario):', dataDescuentosFormacion);
            console.log('datos aportes (pasados del usuario):', dataAportesFormacion);

            return {
              success: true,
              data: {
                mensaje: 'Régimen de Formación Laboral: solo ingreso básico (0121); descuentos y aportes del usuario',
                origen: metadatosOrigen,
                dataIngresos: ingresosFormacion,
                dataDescuentos: dataDescuentosFormacion,
                dataAportes: dataAportesFormacion
              },
              message: 'Servicio ejecutado exitosamente'
            };
          } else if (origen === 'planilla_calculo_service') {
            // Planilla: permitir cualquier régimen (ej. régimen RH); conceptos ya vienen calculados desde tareos/planilla
            console.log('🔄 Origen planilla_calculo_service: se acepta régimen no estándar (ej. RH), usando conceptos ya calculados');
            const dataDescuentosPassthrough = [];
            if (datosCompletos.conceptosUsuario.descuentos && Array.isArray(datosCompletos.conceptosUsuario.descuentos)) {
              datosCompletos.conceptosUsuario.descuentos.forEach(descuento => {
                const dataDescuento = datosCompletos.datosAPIs.conceptosDescuentos?.find(concepto => concepto.codigo === descuento.codigoPlame || concepto.codigo_plame === descuento.codigoPlame);
                if (dataDescuento) {
                  dataDescuentosPassthrough.push({ id_concepto: dataDescuento, valor: descuento.monto });
                }
              });
            }
            const dataAportesPassthrough = [];
            if (datosCompletos.conceptosUsuario.aportes && Array.isArray(datosCompletos.conceptosUsuario.aportes)) {
              datosCompletos.conceptosUsuario.aportes.forEach(aporte => {
                const dataAporte = datosCompletos.datosAPIs.conceptosAportes?.find(concepto => concepto.codigo === aporte.codigoPlame || concepto.codigo_plame === aporte.codigoPlame);
                if (dataAporte) {
                  dataAportesPassthrough.push({ id_concepto: dataAporte, valor: aporte.monto });
                }
              });
            }
            return {
              success: true,
              data: {
                mensaje: 'Boleta desde planilla (régimen no estándar): conceptos calculados por tareos',
                origen: metadatosOrigen,
                dataIngresos: dataIngresos,
                dataDescuentos: dataDescuentosPassthrough,
                dataAportes: dataAportesPassthrough
              },
              message: 'Servicio ejecutado exitosamente'
            };
          }else{
            return {
                success: false,
                error: 'No se puede calcular la boleta para este regimen laboral',
                data: null
              };
          }

          // ahora calculamos los descuentos

          const idRegimenLaboral = datosCompletos.datosAPIs.regimenesLaborales.find(regimen => regimen.nombre === regimenLaboral);
          // calculo descuentos
          const tipoAporte = datosCompletos.datosSalariales.sistemaPensionario;

          let baseCalculo = 0;
          

          // calculo descuentos
          if (tipoAporte ==='AFP'){
            console.log('tipoAporte', tipoAporte);
            let porA = 0
            console.log('datosCompletos.datosSalariales.tipoAfp', datosCompletos.datosSalariales.tipoAfp);
            // primero el tipo de comision el codigo es 0601
            if (datosCompletos.datosSalariales.tipoAfp === 'Flujo'){
              const ComixAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == "AFP " + datosCompletos.datosSalariales.afp || afp.nombre == datosCompletos.datosSalariales.afp);
              console.log('ComixAFP', ComixAFP);
              porA = ComixAFP.comision_fija;
              console.log('porA', porA);
            }else{
              const ComixAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == "AFP " + datosCompletos.datosSalariales.afp || afp.nombre == datosCompletos.datosSalariales.afp);
              console.log('ComixAFP', ComixAFP);
              porA = ComixAFP.comision_variable;
              console.log('porA', porA);
            }

            const formulas = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0601");
            console.log('formula para comision AFP', formulas);

            const formulaAFPcomision = formulas.formula;
            console.log('formulaAFPcomision', formulaAFPcomision);
            
            dataIngresos.forEach(
              ingreso => {
                  const afectaSistemaPrivado = ingreso.id_concepto?.afectaciones?.sistema_privado_pension || ingreso.id_concepto?.sistema_privado_pension;
                  if(afectaSistemaPrivado){
                      baseCalculo += ingreso.valor;
                  }
              }
            );
            const formulaReemplazada = formulaAFPcomision.replace('R', baseCalculo);
            console.log('formulaReemplazada', formulaReemplazada);
            const remmplazarA = formulaReemplazada.replace('A', porA/100);
            console.log('remmplazarA', remmplazarA);
            const descuento = eval(remmplazarA);
            console.log('descuento', descuento);
            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0601" || concepto.codigo_plame === "0601"),
                base_calculo: baseCalculo,
                valor: descuento.toFixed(2)
            })

            // ahora el decuento para el codigo 0606 (Seguro AFP) - Cero si el empleado tiene 65 años o más
            baseCalculo = 0;

            const fechaNacimientoEd = datosCompletos.datosEmpleado?.fechaNacimiento;
            let edadEmpleadoEd = null;
            if (fechaNacimientoEd) {
              const nacimientoEd = new Date(fechaNacimientoEd);
              const hoyEd = new Date();
              edadEmpleadoEd = hoyEd.getFullYear() - nacimientoEd.getFullYear();
              const cumpleEsteAnioEd = new Date(hoyEd.getFullYear(), nacimientoEd.getMonth(), nacimientoEd.getDate());
              if (hoyEd < cumpleEsteAnioEd) edadEmpleadoEd -= 1;
              console.log('📅 Edad empleado (seguro AFP - edición):', edadEmpleadoEd, 'años');
            }

            let SegdescuentoEd = 0;
            if (edadEmpleadoEd !== null && edadEmpleadoEd >= 65) {
              console.log('✅ Empleado con 65 años o más: seguro AFP (0606) = 0');
            } else {
              const SegAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == "AFP " + datosCompletos.datosSalariales.afp || afp.nombre == datosCompletos.datosSalariales.afp);
              console.log('SegAFP', SegAFP);
              const SegA = SegAFP.seguro;
              console.log('SegA', SegA);

              const formulasSegAFP = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0606");
              console.log('formula para seguro AFP', formulasSegAFP);

              const formulaSegAFP = formulasSegAFP.formula;
              console.log('formulaAFPcomision', formulaAFPcomision);

              dataIngresos.forEach(
                ingreso => {
                    const afectaSistemaPrivado = ingreso.id_concepto?.afectaciones?.sistema_privado_pension || ingreso.id_concepto?.sistema_privado_pension;
                    if(afectaSistemaPrivado){
                        baseCalculo += ingreso.valor;
                    }
                }
              );

              const formulaSegReemplazada = formulaSegAFP.replace('R', baseCalculo);
              console.log('formulaSegReemplazada', formulaSegReemplazada);
              const SegReemplazada = formulaSegReemplazada.replace('A', SegA/100);
              console.log('SegReemplazada', SegReemplazada);
              SegdescuentoEd = eval(SegReemplazada);
              console.log('Segdescuento', SegdescuentoEd);
            }

            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0606" || concepto.codigo_plame === "0606"),
                base_calculo: baseCalculo,
                valor: SegdescuentoEd.toFixed(2)
            })

            // ahora el decuento para el codigo 0608
            baseCalculo = 0;

            const AporAFP = datosCompletos.datosAPIs.afps.find(afp => afp.nombre == "AFP " + datosCompletos.datosSalariales.afp || afp.nombre == datosCompletos.datosSalariales.afp);
            console.log('AporAFP', AporAFP);
            const AporA = AporAFP.aporte;
            console.log('AporA', AporA);

            const formulasAporAFP = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0608");
            console.log('formula para aporte AFP', formulasAporAFP);

            const formulaAporAFP = formulasAporAFP.formula;
            console.log('formulaAporAFP', formulaAporAFP);
            
            dataIngresos.forEach(
              ingreso => {
                  const afectaSistemaPrivado = ingreso.id_concepto?.afectaciones?.sistema_privado_pension || ingreso.id_concepto?.sistema_privado_pension;
                  if(afectaSistemaPrivado){
                      baseCalculo += ingreso.valor;
                  }
              }
            );

            const formulaAporReemplazada = formulaAporAFP.replace('R', baseCalculo);
            console.log('formulaAporReemplazada', formulaAporReemplazada);
            const AporReemplazada = formulaAporReemplazada.replace('A', AporA/100);
            console.log('AporReemplazada', AporReemplazada);
            const Apordescuento = eval(AporReemplazada);
            console.log('Apordescuento', Apordescuento);
            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0608" || concepto.codigo_plame === "0608"),
                base_calculo: baseCalculo,
                valor: Apordescuento.toFixed(2)
            })

           console.log('datos descuentos', dataDescuentos);

          }else{//ONP

            // busqueda de id en regimen laboral  
            console.log('idRegimenLaboral', idRegimenLaboral.id);

            // busqueda de formulas segun idRegimenLaboral y codigo plame
            const formulas = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0607");
            console.log('formula PARA ONP', formulas);
            
            const formulaONP = formulas.formula;
            console.log('formulaONP', formulaONP);

            // calculo base de calculo para descuento ONP

            // decuentsos afectos a ONP como tardanzas y inasistencias

            let totalDescuentosBIONP = 0;
            
            datosCompletos.conceptosUsuario.descuentos.forEach(descuento => {
              // Códigos especiales BIO/ONP (0705 y 0704)
              const codigosBIONP = ["0705", "0704","0707"];
              if(codigosBIONP.includes(descuento.codigoPlame)){
                totalDescuentosBIONP += parseFloat(descuento.monto || 0);
                console.log('Descuento BIO/ONP encontrado:', descuento.codigoPlame, 'Monto:', descuento.monto, 'Total acumulado:', totalDescuentosBIONP);
              }
            });
            
            console.log('💰 Total de descuentos BIO/ONP (0705 + 0704 + 0707):', totalDescuentosBIONP);

            baseCalculo   = 0;
            dataIngresos.forEach(
                ingreso => {
                    const afectaSistemaNacional = ingreso.id_concepto?.afectaciones?.sistema_nacional_19990 || ingreso.id_concepto?.sistema_nacional_19990;
                    if(afectaSistemaNacional){
                        baseCalculo += ingreso.valor * 1;
                    }
                }
            );

            baseCalculo = baseCalculo - totalDescuentosBIONP;
            console.log('baseCalculo', baseCalculo);
            const formulaReemplazada = formulaONP.replace('R', baseCalculo);
            console.log('formulaReemplazada', formulaReemplazada);
            const descuento = eval(formulaReemplazada);
            
            dataDescuentos.push({
                id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0607" || concepto.codigo_plame === "0607"),
                base_calculo: baseCalculo,
                valor: descuento.toFixed(2)
            })
            console.log('datos descuentos', dataDescuentos);
          }

          // seguimos con descuentos ahora haremos renta

          // 💰 VALIDAR SI LA CONFIGURACIÓN DE RENTA DE QUINTA ESTÁ ACTIVADA
          const rentaQuintaActivada = datosCompletos.datosAPIs?.rentaQuintaActivada || datosCompletos.datosAPIs?.configuracionRentaQuinta?.activo || false;
          console.log('💸 Configuración de Renta de Quinta (Edición):', datosCompletos.datosAPIs?.configuracionRentaQuinta);
          console.log('🔄 Renta de Quinta Activada (Edición):', rentaQuintaActivada);

          if (rentaQuintaActivada) {
            console.log('✅ Renta de quinta activada, procediendo con el cálculo (modo edición)...');
            
            baseCalculo = 0;
            // primero calculamos los ingresos afectos a renta
            console.log('dataIngresos para renta', dataIngresos);
            dataIngresos.forEach(
                ingreso => {
                    if((ingreso.id_concepto?.afectaciones?.renta_5ta_categoria) || (ingreso.id_concepto?.renta_5ta_categoria)){
                        baseCalculo += ingreso.valor * 1;
                    }
                }
            );

            console.log('baseCalculo Renta', baseCalculo);
            console.log('grati', IgGrati[0].grati);
            console.log('essalud', IgGrati[0].essalud);

            // empesamos con proyecciones de renta

            const proyeccionIngreso  = baseCalculo * 12
            const proyeccionGrati = baseCalculo * IgGrati[0].grati
            const proyeccionEssalud = IgGrati[0].essalud ? (baseCalculo * 0.09) * IgGrati[0].grati : 0

            console.log('proyeccionIngreso', proyeccionIngreso);
            console.log('proyeccionGrati', proyeccionGrati);
            console.log('proyeccionEssalud', proyeccionEssalud);

            // ahora calculamos la renta
            const SumatorioRenta = proyeccionIngreso + proyeccionGrati + proyeccionEssalud
            console.log('SumatorioRenta', SumatorioRenta);

            
            if(SumatorioRenta > datosCompletos.datosAPIs.uit.monto * 7){
              console.log('se aplica renta');
              const BIrenta = SumatorioRenta - (datosCompletos.datosAPIs.uit.monto * 7)
              console.log('renta', BIrenta);

              // empesamos con los tramos de renta
              const tramo1 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 1)
              if (BIrenta > tramo1.hasta * datosCompletos.datosAPIs.uit.monto){
                  const tramo2 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 2)
                  if (BIrenta > tramo2.hasta * datosCompletos.datosAPIs.uit.monto){
                      const tramo3 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 3)
                      if (BIrenta > tramo3.hasta * datosCompletos.datosAPIs.uit.monto){
                          const tramo4 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 4)
                          if (BIrenta > tramo4.hasta * datosCompletos.datosAPIs.uit.monto){
                              const tramo5 = datosCompletos.datosAPIs.tramosRenta.find(tramo => tramo.tramo === 5)
                              if (BIrenta > tramo5.hasta * datosCompletos.datosAPIs.uit.monto){
                                const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                                const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                                const RetencionTramo3 = ((BIrenta - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo3.tasa/100))
                                const RetencionTramo4 = ((BIrenta - (tramo3.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo4.tasa/100))
                                const RetencionTramo5 = ((BIrenta - (tramo4.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo3.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo5.tasa/100))
                                const RetencionRenta = (RetencionTramo1 + RetencionTramo2 + RetencionTramo3 + RetencionTramo4 + RetencionTramo5)/12
                                console.log('RetencionRenta', RetencionRenta);
                                dataDescuentos.push({
                                  id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605" || concepto.codigo_plame === "0605"),
                                  base_calculo: baseCalculo,
                                  valor: RetencionRenta.toFixed(2)
                              })
                              }
                          }else{
                            const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                            const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                            const RetencionTramo3 = ((BIrenta - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo3.tasa/100))
                            const RetencionTramo4 = ((BIrenta - (tramo3.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo4.tasa/100))
                            const RetencionRenta = (RetencionTramo1 + RetencionTramo2 + RetencionTramo3 + RetencionTramo4)/12
                            console.log('RetencionRenta', RetencionRenta);
                            dataDescuentos.push({
                              id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605" || concepto.codigo_plame === "0605"),
                              base_calculo: baseCalculo,
                              valor: RetencionRenta.toFixed(2)
                          })
                          }
                      }else{
                        const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                        const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                        const RetencionTramo3 = ((BIrenta - (tramo2.hasta * datosCompletos.datosAPIs.uit.monto) - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo3.tasa/100))
                        const RetencionRenta = (RetencionTramo1 + RetencionTramo2 + RetencionTramo3)/12
                        console.log('RetencionRenta', RetencionRenta);
                        dataDescuentos.push({
                          id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605" || concepto.codigo_plame === "0605"),
                          base_calculo: baseCalculo,
                          valor: RetencionRenta.toFixed(2)
                      })
                      }
                  }else{
                    const RetencionTramo1 = ((tramo1.hasta * datosCompletos.datosAPIs.uit.monto) * (tramo1.tasa/100))
                    const RetencionTramo2 = ((BIrenta - (tramo1.hasta * datosCompletos.datosAPIs.uit.monto)) * (tramo2.tasa/100))
                    const RetencionRenta = (RetencionTramo1 + RetencionTramo2)/12
                    console.log('RetencionRenta', RetencionRenta);
                    dataDescuentos.push({
                      id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605" || concepto.codigo_plame === "0605"),
                      base_calculo: baseCalculo,
                      valor: RetencionRenta.toFixed(2) 
                  })
                  }
              }else{
                const RetencionRenta = (BIrenta * (tramo1.tasa/100))/12
                console.log('RetencionRenta', RetencionRenta);
                dataDescuentos.push({
                  id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0605" || concepto.codigo_plame === "0605"),
                  base_calculo: baseCalculo,
                  valor: RetencionRenta.toFixed(2)
              })
              }
            }else{
              console.log('no se aplica renta');
            }
          } else {
            console.log('❌ Renta de quinta desactivada en la configuración, saltando cálculo (modo edición)...');
          }
          datosCompletos.conceptosUsuario.descuentos.forEach(descuento => {
            // ✅ CORREGIDO: Solo pasa si NO tiene ninguno de estos códigos
            const codigosExcluidos = ["0607", "0601", "0606", "0608"];
            if(!codigosExcluidos.includes(descuento.codigoPlame)){
              console.log('Paso la validacion con codigo', descuento.codigoPlame);
              const dataDescuento = datosCompletos.datosAPIs.conceptosDescuentos.find(concepto => concepto.codigo === descuento.codigoPlame || concepto.codigo_plame === descuento.codigoPlame);
              dataDescuentos.push({
                id_concepto: dataDescuento,
                valor: descuento.monto
              });
              console.log('datos descuentos excluidos de afp y onp y renta', dataDescuentos);
          }
          });

          // ahora calculamos los aportes
          // busqueda de id en regimen laboral  
          console.log('idRegimenLaboral', idRegimenLaboral.id);

          // busqueda de formulas segun idRegimenLaboral y codigo plame
          const formulasEssalud = datosCompletos.datosAPIs.formulas.find(formula => formula.id_tipo === idRegimenLaboral.id && formula.codigo === "0804");
          console.log('formula para Essalud', formulasEssalud);
          
          const formulaEssalud = formulasEssalud.formula;
          console.log('formulaEssalud', formulaEssalud);

          // calculo base de calculo para aporte EsSalud

          // 
          baseCalculo = 0;
          dataIngresos.forEach(
              ingreso => {
                  console.log('ingreso', ingreso);
                  const afectaEssalud = ingreso.id_concepto?.afectaciones?.essalud_regular || ingreso.id_concepto?.essalud_regular;
                  if(afectaEssalud){
                      baseCalculo += ingreso.valor * 1;
                  }
              }
          );

          console.log('baseCalculo Essalud', baseCalculo);

          // Restar descuentos BIO/ONP (0705 y 0704) de la base de cálculo para EsSalud
          let totalDescuentosBIONP = 0;
          
          datosCompletos.conceptosUsuario.descuentos.forEach(descuento => {
            // Códigos especiales BIO/ONP (0705 y 0704)
            const codigosBIONP = ["0705", "0704","0707"];
            if(codigosBIONP.includes(descuento.codigoPlame)){
              totalDescuentosBIONP += parseFloat(descuento.monto || 0);
              console.log('Descuento BIO/ONP encontrado para EsSalud:', descuento.codigoPlame, 'Monto:', descuento.monto, 'Total acumulado:', totalDescuentosBIONP);
            }
          });
          
          console.log('💰 Total de descuentos BIO/ONP para EsSalud (0705 + 0704 + 0707):', totalDescuentosBIONP);
          
          baseCalculo = baseCalculo - totalDescuentosBIONP;
          console.log('baseCalculo EsSalud después de restar BIO/ONP:', baseCalculo);

          // comprar con el sueldo minimo
          if(baseCalculo < datosCompletos.datosAPIs.sueldoMinimo.monto){
            baseCalculo = datosCompletos.datosAPIs.sueldoMinimo.monto;
          }

          const formulaReemplazadaEss = formulaEssalud.replace('R', baseCalculo);
          console.log('formulaReemplazadaEss', formulaReemplazadaEss);
          const descuentoEssalud = eval(formulaReemplazadaEss);
          console.log('descuentoEssalud', descuentoEssalud);

          dataAportes.push({
              id_concepto: datosCompletos.datosAPIs.conceptosPlame.find(concepto => concepto.codigo === "0804" || concepto.codigo_plame === "0804"),
              base_calculo: baseCalculo,
              valor: descuentoEssalud.toFixed(2)
          })

          console.log('datos conceptos aportes', datosCompletos.conceptosUsuario.aportes);
          datosCompletos.conceptosUsuario.aportes.forEach(aporte => {
            // ✅ CORREGIDO: Solo pasa si NO tiene ninguno de estos códigos
            const codigosExcluidos = ["0804"];
            if(!codigosExcluidos.includes(aporte.codigoPlame)){
              console.log('Paso la validacion con codigo', aporte.codigoPlame);
              console.log('concepto.codigo', datosCompletos.datosAPIs.conceptosAportes);
              const dataAporte = datosCompletos.datosAPIs.conceptosAportes.find(concepto => concepto.codigo || concepto.codigo_plame === aporte.codigoPlame);
              console.log('dataAporte', dataAporte);
              dataAportes.push({
                id_concepto: dataAporte,
                valor: aporte.monto
              });
              console.log('datos aportes excluidos de essalud', dataAportes);
          }
          });

          return {
            success: true,
            data: {
              // Aquí devuelves los resultados de tus cálculos
              mensaje: 'Datos recibidos correctamente - implementa tu lógica aquí',
              origen: metadatosOrigen,
              dataIngresos: dataIngresos,
              dataDescuentos: dataDescuentos,
              dataAportes: dataAportes
            },
            message: 'Servicio ejecutado exitosamente'
          };
          
        }else{
            const dataIngresos = [];
            datosCompletos.conceptosUsuario.ingresos.forEach(ingreso => {
                const dataIngreso = datosCompletos.datosAPIs.conceptosIngresos.find(concepto => concepto.codigo === ingreso.codigoPlame || concepto.codigo_plame === ingreso.codigoPlame);
                dataIngresos.push({
                  id_concepto: dataIngreso,
                  valor: ingreso.monto
                });
              });
            const dataDescuentos = [];
            if (datosCompletos.conceptosUsuario.descuentos && Array.isArray(datosCompletos.conceptosUsuario.descuentos)) {
              datosCompletos.conceptosUsuario.descuentos.forEach(descuento => {
                const dataDescuento = datosCompletos.datosAPIs.conceptosDescuentos?.find(concepto => concepto.codigo === descuento.codigoPlame || concepto.codigo_plame === descuento.codigoPlame);
                if (dataDescuento) {
                  dataDescuentos.push({ id_concepto: dataDescuento, valor: descuento.monto });
                }
              });
            }
            const dataAportes = [];
            if (datosCompletos.conceptosUsuario.aportes && Array.isArray(datosCompletos.conceptosUsuario.aportes)) {
              datosCompletos.conceptosUsuario.aportes.forEach(aporte => {
                const dataAporte = datosCompletos.datosAPIs.conceptosAportes?.find(concepto => concepto.codigo === aporte.codigoPlame || concepto.codigo_plame === aporte.codigoPlame);
                if (dataAporte) {
                  dataAportes.push({ id_concepto: dataAporte, valor: aporte.monto });
                }
              });
            }
            console.log('dataIngresos', dataIngresos);
            console.log('dataDescuentos', dataDescuentos);
            console.log('dataAportes', dataAportes);
            return {
              success: true,
              data: {
                mensaje: 'Datos recibidos correctamente - implementa tu lógica aquí',
                origen: metadatosOrigen,
                dataIngresos: dataIngresos,
                dataDescuentos: dataDescuentos,
                dataAportes: dataAportes
              },
              message: 'Servicio ejecutado exitosamente'
            };
        }
      }
      
      
      return {
        success: true,
        data: {
          // Aquí devuelves los resultados de tus cálculos
          mensaje: 'Datos recibidos correctamente - implementa tu lógica aquí',
          origen: metadatosOrigen,
          //dataIngresos: dataIngresos
        },
        message: 'Servicio ejecutado exitosamente'
      };

    } catch (error) {
      console.error('❌ Error en servicio de cálculos:', error);
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  },

  /**
   * Determinar la fuente basada en el origen
   */
  determinarFuente(origen) {
    const fuentes = {
      'formulario_empleados_boton_generar': 'Formulario Empleados - Botón Generar',
      'formulario_empleado': 'Formulario de Empleado',
      'planilla_masiva': 'Planilla Masiva',
      'api_externa': 'API Externa',
      'importacion': 'Importación de Datos',
      'recalculo': 'Recálculo Automático',
      'test': 'Pruebas/Testing'
    };
    
    return fuentes[origen] || 'Origen Desconocido';
  },

  /**
   * Obtener contexto adicional basado en el origen
   */
  obtenerContexto(origen) {
    const contextos = {
      'formulario_empleados_boton_generar': {
        descripcion: 'Cálculo iniciado desde el botón Generar del formulario de empleados',
        requiereValidacion: true,
        permiteCambios: true
      },
      'formulario_empleado': {
        descripcion: 'Cálculo individual desde formulario de empleado',
        requiereValidacion: true,
        permiteCambios: true
      },
      'planilla_masiva': {
        descripcion: 'Procesamiento masivo de planilla',
        requiereValidacion: false,
        permiteCambios: false
      },
      'api_externa': {
        descripcion: 'Llamada desde API externa',
        requiereValidacion: true,
        permiteCambios: false
      },
      'importacion': {
        descripcion: 'Importación de datos externos',
        requiereValidacion: true,
        permiteCambios: true
      },
      'recalculo': {
        descripcion: 'Recálculo automático del sistema',
        requiereValidacion: false,
        permiteCambios: false
      },
      'test': {
        descripcion: 'Ejecución de pruebas',
        requiereValidacion: false,
        permiteCambios: true
      }
    };
    
    return contextos[origen] || {
      descripcion: 'Contexto no definido',
      requiereValidacion: true,
      permiteCambios: true
    };
  }
};

export default calculosBoletaService; 